import HealthIcon from "@/assets/healthworkspace.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const HealthLogo = (props: Props) => (
  <LogoImage imgSrc={HealthIcon} alt="Health Workspace Logo" size="navbar" {...props} />
);
